import React from 'react';
import { Building, Calendar, User } from 'lucide-react';

const ModelQuotesCard = ({ quote, onClick, clients = [], contacts = [] }) => {
  // Find the actual client and contact from the foreign keys
  const actualClient = quote.client_id ? clients.find(c => c.id === quote.client_id) : null;
  const actualContact = quote.contact_id ? contacts.find(c => c.id === quote.contact_id) : null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--dark-elevated)',
        border: '1px solid var(--gray-600)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-4)',
        cursor: 'pointer',
        transition: 'all var(--transition-fast)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--gray-500)';
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--gray-600)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {/* Card Header */}
      <div
        style={{
          marginBottom: 'var(--space-3)',
          paddingBottom: 'var(--space-3)',
          borderBottom: '1px solid var(--gray-700)',
        }}
      >
        <h3
          style={{
            fontSize: 'var(--text-lg)',
            fontWeight: 'var(--font-semibold)',
            color: 'var(--gray-50)',
            margin: '0 0 var(--space-2) 0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={quote.project_name}
        >
          {quote.project_name || 'Unnamed Quote'}
        </h3>
      </div>

      {/* Card Body */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-2)',
        }}
      >
        {/* Display actual client name, fallback to form company name */}
        {(actualClient?.name || quote.company_name) && (
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 'var(--space-2)',
            }}
          >
            <Building
              size={14}
              style={{
                flexShrink: 0,
                marginTop: '2px',
                color: 'var(--gray-400)',
              }}
            />
            <span
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--gray-300)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={actualClient?.name || quote.company_name}
            >
              {actualClient?.name || quote.company_name}
            </span>
          </div>
        )}

        {/* Display actual contact name, fallback to form contact name */}
        {(actualContact?.name || quote.name) && (
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 'var(--space-2)',
            }}
          >
            <User
              size={14}
              style={{
                flexShrink: 0,
                marginTop: '2px',
                color: 'var(--gray-400)',
              }}
            />
            <span
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--gray-300)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={actualContact?.name || quote.name}
            >
              {actualContact?.name || quote.name}
            </span>
          </div>
        )}

        {quote.quote_due_date && (
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 'var(--space-2)',
            }}
          >
            <Calendar
              size={14}
              style={{
                flexShrink: 0,
                marginTop: '2px',
                color: 'var(--gray-400)',
              }}
            />
            <span
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--gray-300)',
              }}
            >
              {formatDate(quote.quote_due_date)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModelQuotesCard;